import { Indicator, Toast } from 'mint-ui';

var loading = function (status = true) {
    if (status) {
        Indicator.open({
          //加载提示框
          text: '加载中...',
            // spinnerType: 'fading-circle'
        });
    } else {
        Indicator.close();
    }
}
var tip = function (message = '网络出错了，请重试！', position = 'middle', duration = 2000) {
    Toast({
        message: message,
        position: position,
        duration: duration
    });
}

export default {
    loading,
    tip
}



// WEBPACK FOOTER //
// ./src/assets/js/notice.js